import React from "react";
import { PageLayout } from "../../components";

export default function VehicleVariantSkeleton() {
  return (
    <PageLayout>
      <PageLayout.Header title="Vehicle details" step={1} />
      <PageLayout.Content>
        <div
          className="ch-skeleton ch-mb--2 "
          data-testid="email-my-offer-skeleton-div"
          style={{ height: "84px", marginBottom: "12px" }}
        />
        <div
          className="ch-skeleton ch-mb--2 "
          style={{ height: "78px", marginBottom: "30px" }}
        />
        <div
          className="ch-skeleton ch-mb--2 ch-rounded"
          style={{ height: "48px" }}
        />
      </PageLayout.Content>
    </PageLayout>
  );
}
